import { render, staticRenderFns } from "./DocFaceAnalysis.vue?vue&type=template&id=651a3698&scoped=true"
import script from "./DocFaceAnalysis.vue?vue&type=script&lang=js"
export * from "./DocFaceAnalysis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651a3698",
  null
  
)

export default component.exports